import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Role } from '../../core/enums/role.enum';
import { AuthService } from '../../shared/services/auth.services';

interface BreadcrumbItem {
  label: string;
  url?: string;
}

/**
 * Mantém a regra de contexto do breadcrumb isolada no fluxo de dependentes.
 * O App continua tratando breadcrumbs de forma genérica para as demais telas.
 */
export const dependenteBreadcrumbResolver: ResolveFn<BreadcrumbItem[]> = (route) => {
  const breadcrumb = (route.data['breadcrumb'] as BreadcrumbItem[] | undefined) ?? [];

  if (route.queryParamMap.get('contexto') !== 'solicitacao-afastamento' || breadcrumb.length === 0) {
    const authService = inject(AuthService);
    const isGestao = authService.hasAnyRole([
      Role.DEPENDENTE_COORDENADOR_CADASTRAR,
      Role.DEPENDENTE_COORDENADOR_ANALISAR,
    ]);

    const raiz = isGestao ? 'Gestão de Afastamentos' : 'Afastamentos';
    const menuDependentes = isGestao ? 'Gestão de Dependentes' : 'Meus Dependentes';

    return [
      { label: raiz, url: '/afastamento' },
      { ...breadcrumb[0], label: menuDependentes, url: '/dependente' },
      ...breadcrumb.slice(1),
    ];
  }

  const isAnalise = route.routeConfig?.path === 'analisar/:id';
  const origem = isAnalise ? 'Gestão de Afastamentos' : 'Solicitar Afastamentos';

  return [
    { label: 'Afastamentos', url: '/afastamento' },
    {
      label: origem,
      url: isAnalise ? '/afastamento' : '/afastamento/novo/selecionar-tipo',
    },
    ...breadcrumb.slice(1),
  ];
};
